import DigitalStoreSDK from '@redant/digital-store-client-sdk-coty'

export default new DigitalStoreSDK({
  baseUrl: ''
})
